import angular from 'angular';
import toastr from 'angular-toastr';
import gettext from 'angular-gettext';
import slugifier from 'angular-slugify';

export default angular.module('cms.add.page.dialog.service', [toastr, gettext,"slugifier"])
    .factory('addPageDialog', ($uibModal, $q, CMSAuthService, Slug, gettextCatalog) => {

        let service = {};

        service.open = () => {
            let user = CMSAuthService.getUser();
            let title = gettextCatalog.getString('New page') + ' ' + user.email.split('@')[0].replace('.',' ');
            let modalInstance = $uibModal.open({
                animation: true,
                template: require('../templates/addPageDialog.html'),
                size: 'md',
                controllerAs: '$ctrl',
                controller: function ($scope, PageResource, toastr, gettextCatalog, TemplateResource, CONFIG) {
                    this.errors = {};
                    this.pending = false;
                    this.templates =[];
                    TemplateResource.findAll(response => {
                        response.data.forEach((data) => {
                            this.templates.push({'value' : data,'label': data.title});
                        })

                    });
                    this.page = {
                        title: title,
                        status: 'public',
                        slug: Slug.slugify(title),
                        template: null
                    };

                    this.create = () => {
                        this.pending = true;
                        if(!this.page.template) {
                            this.page.globalBackgroundColor = '#ededed';
                            this.page.globalColor = '#000000';
                            this.page.globalLinkColor = '#209e91';
                            this.page.globalTextConfig = {
                                "h1": {
                                    "fontFamily": "Ubuntu"
                                },
                                "h2": {
                                    "fontFamily": "Ubuntu"
                                },
                                "h3": {
                                    "fontFamily": "Ubuntu"
                                },
                                "href": {
                                    "color": "#209e91"
                                },
                                "text": {
                                    "fontFamily": "Ubuntu"
                                },
                                "linkHover": {
                                    "color": "#209e91"
                                }
                            }
                        }
                        return PageResource.save(this.page,
                            response => {
                                this.errors = {};
                                toastr.success(
                                    gettextCatalog.getString('Page {{title}} added!', {title: this.page.title}),
                                    gettextCatalog.getString('Success')
                                );
                                this.pending = false;
                                $scope.$close(response);
                            },
                            response => {
                                if (response.status === 400) {
                                    this.errors = response.data;
                                }
                                this.pending = false;
                            }
                        ).$promise;


                    };

                    /**
                     * Broadcast slug recalculation request
                     */
                    this.updateSlug = function () {
                        //@TODO: Zaproponować i przedyskutować sposób wyniesienia do osobnego serwisu
                        if (!this.page.id || !this.page.slug) {
                            $scope.$broadcast('slug.recalc');
                        }
                    };

                    /**
                     * Actions to validate slug
                     * Returns promise;
                     * @param data
                     */
                    this.validateSlug = function (data) {
                        //@TODO: Zaproponować i przedyskutować sposób wyniesienia do osobnego serwisu
                        this.errors.slug = [];
                        if (!data) {
                            return $q.when([]);
                        }

                        let pageResourcePromise = PageResource.findAll({slug_strict: data}).$promise;

                        pageResourcePromise.then((response) => {

                            angular.forEach(response.data, function (value) {
                                if (value.id !== this.page.id) {
                                    this.errors.slug = [gettextCatalog.getString('This value is already used')];
                                }
                                else {
                                    this.errors.slug = null;
                                }
                            }, this);
                        });

                        return pageResourcePromise;
                    };


                    this.getSiteUrl = (slug) => {
                        return CONFIG.PUBLIC_SITE_URL.replace('__SITE_SLUG__', slug);
                    }
                }

            });

            return modalInstance.result;
        };

        return service;

    }).name


// WEBPACK FOOTER //
// ./src/cmsPages/Pages/Services/AddPageDialog.js